import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class SecureSessionService {

  constructor() { }
  private sessionKey = 'userSession';
  private secretKey = 'your-secret-key';

  setSession(data: any): void {
    console.log(data);
    
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
    localStorage.setItem('session', encryptedData);
    // sessionStorage.setItem(this.sessionKey, encryptedData);
  }

  getSession(): any {
    const encryptedData = localStorage.getItem('session');
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    return null;
  }


  setSessionChild(data: any): void {
    console.log(data);
    
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), this.secretKey).toString();
    localStorage.setItem('sessionChild', encryptedData);
    // sessionStorage.setItem(this.sessionKey, encryptedData);
  }

  getSessionChild(): any {
    // const encryptedData = sessionStorage.getItem(this.sessionKey);
    
    const encryptedData = localStorage.getItem('sessionChild');
    if (encryptedData) {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
    return null;
  }

  setToken(token: string): void {
    const encrypted = CryptoJS.AES.encrypt(token, this.secretKey).toString();
    localStorage.setItem('authToken', encrypted);
  }

  getToken(): string | null {
    const encrypted = localStorage.getItem('authToken');
    if (encrypted) {
      const bytes = CryptoJS.AES.decrypt(encrypted, this.secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    }
    return null;
  }

  clearSession(): void {
    // Remove only authentication and session-specific keys.
    // Report preference keys (reportState:*, reportFavourites:*, report-columns:*)
    // are intentionally left intact so the user's saved states survive logout.
    localStorage.removeItem(this.sessionKey); // 'userSession'
    localStorage.removeItem('session');
    localStorage.removeItem('sessionChild');
    localStorage.removeItem('authToken');
    localStorage.removeItem('loginData');
    sessionStorage.clear();
  }
}
